import { Link } from "react-router-dom";

export default function Footer(props) {

  return (
    <footer className="bg-indigo-950 w-full relative">
      <div className="mx-auto max-w-7xl overflow-hidden px-6 py-6">
        <p className="text-center text-sm leading-5 text-gray-300 px-4 md:px-8 lg:px-12">
          Copyright &copy; {new Date().getFullYear()} Astoria Labs. All rights reserved.
          <span className="mx-2 text-gray-500">·</span>
          <Link to="/terms" className="text-gray-400 hover:text-gray-200 transition-colors">Terms</Link>
          <span className="mx-2 text-gray-500">·</span>
          <Link to="/privacy" className="text-gray-400 hover:text-gray-200 transition-colors">Privacy</Link>
        </p>
      </div>
    </footer>
  )
}
